import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Plans from "./Plans";
import Classes from "./Classes";
import Teachers from "./Teachers";
import TicketStudent from "./Tickets";
import Levelscore from "./Levelscore";
import PersonalInfo from "./PersonalInfo";
import Tabs from "../../components/Tabs";
import StudentSubscription from "./Subscription";
import Header from "../../components/Header/NewHeader";
import { getStudentById } from "../../store/middleware";
import SideMenu from "../../components/SideMenu/SideMenu";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import HomeStudentStudyAI from "../../components/HomeStudentStudyAI";
import { setLevelStudent } from "../../store/slices/companyManager.slice";
import UsersIcon from "../../assets/images/icons/icon_students_header.svg";
import HomeStudentDetailtContent from "../../components/HomeStudentDetailtContent";
import { setActiveTabStudent, setLevels } from "../../store/slices/generics.slice";

function DetailStudents() {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const { activeTabStudent } = useSelector((state) => state.genericReducer);
  const { studentManagement } = useSelector((state) => state.companyManagerReducer);

  const [activeTab, setActiveTab] = useState(activeTabStudent);

  const isCompanyManager = user?.role === "companyManager";
  const hasStudentManagement = Object.values(studentManagement).length > 0;

  const options = [
    "PERSONAL_INFO",
    "SUBSCRIPTION",
    "PLANS",
    "CARD_PLAN_CLASS",
    "LEVEL_SCORE",
    "ITEM_TEACHERS",
    "TICKETS",
    "CONTENT",
    isCompanyManager ? "AI_PRACTICE" : null,
  ].filter(Boolean);

  const getData = async () => {
    dispatch(setLevels([]));
    dispatch(setLevelStudent([]));
    await dispatch(getStudentById(id));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(setActiveTabStudent(activeTab));
    // eslint-disable-next-line
  }, [activeTab]);

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header t={t} title={t("ITEM_STUDENTS")} icon={<img src={UsersIcon} alt="UsersIcon" />} typeIcon="custom" />

        <div className="content">
          {Object.values(studentManagement).length > 0 && (
            <div className="rating-box">
              <div className="teacher-info">
                <h2>{decryptIfEncrypted(studentManagement?.name)}</h2>
                {studentManagement?.students[0]?.studentLanguages?.length > 0 && (
                  <p>
                    {t("NATIVE_LANGUAGE")}:{" "}
                    {decryptIfEncrypted(studentManagement?.students[0]?.studentLanguages[0]?.language?.name)}
                  </p>
                )}
                <p>
                  {t("COUNTRY")}: {decryptIfEncrypted(studentManagement?.country?.name)}
                </p>
              </div>
            </div>
          )}
        </div>

        <Tabs options={options} activeTab={activeTabStudent} setActiveTab={setActiveTab}>
          {options[0] === activeTab && hasStudentManagement && <PersonalInfo id={id} />}
          {options[1] === activeTab && hasStudentManagement && (
            <StudentSubscription id={id} setActiveTab={setActiveTab} />
          )}
          {options[2] === activeTab && hasStudentManagement && <Plans id={id} />}
          {options[3] === activeTab && hasStudentManagement && <Classes id={id} />}
          {options[4] === activeTab && hasStudentManagement && <Levelscore id={id} />}
          {options[5] === activeTab && hasStudentManagement && <Teachers id={id} />}
          {options[6] === activeTab && hasStudentManagement && <TicketStudent id={id} />}
          {options[6] === activeTab && hasStudentManagement && <TicketStudent id={id} />}
          {options[7] === activeTab && hasStudentManagement && (
            <HomeStudentDetailtContent student={studentManagement?.students[0]} />
          )}
          {options[8] === activeTab && hasStudentManagement && (
            <HomeStudentStudyAI student={studentManagement?.students[0]} />
          )}
        </Tabs>
      </section>
    </div>
  );
}

export default DetailStudents;
